import mixins from 'vue-typed-mixins';
import _ from 'lodash';

import Header from '@/user/components/header/Header.vue';
import BackButton from '@/user/components/header/backButton/BackButton.vue';
import LogoutButton from '@/user/components/header/logoutButton/LogoutButton.vue';
import UnitSelectCalc from '@/user/pages/authorized/unitSelect/calc/UnitSelectCalc.vue';
import UnitSelectJapanese from '@/user/pages/authorized/unitSelect/japanese/UnitSelectJapanese.vue';
import UnitSelectNumber from '@/user/pages/authorized/unitSelect/number/UnitSelectNumber.vue';
import UnitSelectWord from '@/user/pages/authorized/unitSelect/word/UnitSelectWord.vue';

import RoutesMixin from '@/user/mixins/RoutesMixin';




export default mixins(RoutesMixin).extend({

  name: 'UnitSelect',

  components: {
    Header,
    BackButton,
    LogoutButton,
    UnitSelectCalc,
    UnitSelectJapanese,
    UnitSelectNumber,
    UnitSelectWord,
  },

  computed: {
    title(): string {
      return `${this.$route.params.courseName}メニュー`;
    },
    component(): string {
      return `UnitSelect${_.capitalize(this.$route.params.courseId)}`;
    },
  },

  methods: {
    back(): void {
      this.$router.push(this.routes.CourseSelect);
    },
  },

});
